// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Facility  {
    _originalTypeClassName = "Loom.BO.Facility";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Facility.translate = translateService;
}
this.AttendanceSchedules = [];
this.Id = null;
this.Address = null;
this.City = null;
this.PostCode = null;
this.Name = null;
this.Description = null;
this.Type = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Address:any;
City:any;
PostCode:any;
Name:any;
Description:any;
Type:any;
Country:any;
Organisation:any;
AttendanceSchedules:any;
static setCountry = ($this, value) => {
var oldValue = $this.Country;
$this.Country = value;
if (value != null) {
}
}
static setOrganisation = ($this, value) => {
var oldValue = $this.Organisation;
$this.Organisation = value;
if (value != null) {
if (oldValue != null) {
Domain.Organisation.removeFacilities(oldValue, $this);
}
Domain.Organisation.addFacilities(value, $this);
}
}
static setAttendanceSchedules = ($this, items) => {
                if (items == null) items = [];
                if ($this.AttendanceSchedules == null) $this.AttendanceSchedules = [];

                const copyItems = Common.cloneObject(items);

                while ($this.AttendanceSchedules.length > 0) {
                    Domain.Facility.removeAttendanceSchedules($this, $this.AttendanceSchedules[0]);
                }

                Domain.Facility.addManyAttendanceSchedules($this, copyItems);
            }
static addManyAttendanceSchedules = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Facility.addAttendanceSchedules($this, items[i]);
                }
            }
static addAttendanceSchedules = ($this, item) => {
                if ($this.AttendanceSchedules == null) $this.AttendanceSchedules = [];
                if (item == null || $this.AttendanceSchedules.indexOf(item) > -1) return;
                $this.AttendanceSchedules.push(item);
if (item.Facility != $this) {
Domain.OfficeAttendanceSchedule.setFacility(item, $this);
}
}
static addRangeAttendanceSchedules = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Facility.addAttendanceSchedules($this, item));
            }
static removeAttendanceSchedules = ($this, item) => {
                if ($this == null || $this.AttendanceSchedules == null || $this.AttendanceSchedules.indexOf(item) === -1) return;
                var _index = $this.AttendanceSchedules.indexOf(item);
                $this.AttendanceSchedules.splice(_index, 1);
item.Facility = null;
}
static clearAttendanceSchedules = ($this) => { $this.AttendanceSchedules = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}